import { render } from "./ScrollDown.vue?vue&type=template&id=333e7d96&scoped=true"
const script = {}

import "./ScrollDown.vue?vue&type=style&index=0&id=333e7d96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333e7d96"]])

export default __exports__